import React from 'react';
import styled from 'styled-components';
import { A } from '../../base';

const StyledName = styled.span`
	display: inline-block;
	margin-right: 0.5rem;
`;

const StyledHeading = styled.a`
	display: block;
	max-width: 80%;
	font-size: 1.6rem;
	line-height: 1.6;
	color: ${({ theme }) => theme.colors.black};
	margin-bottom: 1rem;
`;

const StyledPurposes = styled.span`
	display: inline-block;
	font-size: 1.4rem;
	line-height: 1.6;

	${A} {
		margin-left: 0.5rem;
	}
`;

const Item = ({
	name,
	nameInfo,
	purposes,
	turnOffUrl,
	infoUrl,
	learnMore
}) => {
	return (
		<>
			<StyledHeading
				href={turnOffUrl}
				target="_blank"
				rel="noopener noreferrer"
				className="name-wrapper">
				<StyledName>{name}</StyledName>
				{nameInfo}
			</StyledHeading>
			<StyledPurposes>
				{purposes}
				<A href={infoUrl} target="_blank" rel="noopener noreferrer">
					{learnMore}
				</A>
			</StyledPurposes>
		</>
	);
};

export default Item;
